import React, { useContext } from "react";
import "./ResourceTable.css";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { toast, ToastContainer } from "react-toastify";
import {
  Editicon,
  Deleteicon,
  Viewicon,
} from "../../../../../Components/IconComponents";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";
import Table from "../../../../../Components/UiComponents/Table/Table";
import { Modal, Button } from "react-bootstrap";
import Moment from "react-moment";
import { resourcemgmtcolumnsForExport } from "../../../../../JsonData/ResourceManagementConfig";
import { getData, putDataWithBody } from "../../../../../Services/Services";
import { setTableData } from "../../../../../CentralStore/ExportLMSTable/dataSlice";
import { getExportedColumnsData } from "../../../../../Components/UiComponents/utils";
import {
  resourceListURL,
  deleteResourcebyId,
  resourceCatListURL,
  resourceTypListURL,
  resourceActivityListURL,
  findRegionsByUser,
} from "../../../../../Services/EndPoints";
import SelectComponent from "../../../../../Components/UiComponents/SelectComponent/SelectComponent";
import Confirmpopup from "../../../Common/ConfirmPopup/Confirmpopup";
import { useDispatch } from "react-redux";
import TextEllipsis from "../../../../../Components/UiComponents/TextEllipsis/TextEllipsis";
import Loader from "react-spinner-loader";
import { RoleContext } from "../../../../..";

const ResourceTable = forwardRef((props, ref) => {
  const [loader, setLoader] = useState(false);
  const qs = require("qs");
  const [resourceData, setResourceData] = useState([]);
  const [resourceSrchdData, setResourceSrchdData] = useState(null);
  const [resourceCategoryData, setResourceCategoryData] = useState([]);
  const [resourceTypeData, setResourceTypeData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { roleName } = useContext(RoleContext);

  const [searchData, setSearchData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("All districts");
  const [districtsLoading, setDistrictsLoading] = useState(false);

  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);


  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const districts = await getData(findRegionsByUser);
        // Add "All districts" option at the beginning
        setDistrictData([{ value: "All districts", id: "all" }, ...districts]);
      } catch (error) {
        console.error("Error fetching districts:", error);
      }
    };
    fetchDistricts();
  }, []);

  // Add this function to filter by district
  const filterByDistrict = (event) => {
    const selectedId = event.target.value;
    setSelectedDistrict(selectedId);

    if (selectedId === "all") {
      setResourceSrchdData(null); // Show all data
      setRowCount(resourceData.length);
    } else {
      // Find the district name that matches the selected ID
      const selectedDistrict = districtData.find(d => d.id.toString() === selectedId.toString());

      if (selectedDistrict) {
        const filteredData = resourceData.filter(item =>
          item.dist_name &&
          item.dist_name.toString().trim().toLowerCase() ===
          selectedDistrict.value.toString().trim().toLowerCase()
        );

        setResourceSrchdData(filteredData.length ? filteredData : []);
        setRowCount(filteredData.length);
        // Debugging logs
        console.log("Selected District ID:", selectedId);
        console.log("Selected District Name:", selectedDistrict.value);
        console.log("Filtered Data:", filteredData);
      } else {
        setResourceSrchdData([]);
        setRowCount(0);
      }
    }
  };


  useEffect(() => {
    getResourceList();
    getRsourceTypeList();
    if (props.locationInstance && props.locationInstance.msg != "") {
      toast.success(props.locationInstance.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
    }
  }, []);

  const addNewHandler = () => {
    navigate("/resource-list/create-resource");
  };

  // Helper function to sort data by creation date (newest first)
  const sortDataByCreatedDate = (data) => {
    return [...data].sort((a, b) => {
      // Assuming your data has a created_on or similar field
      // Adjust the field name based on your actual data structure
      const dateA = new Date(a.created_on || a.createdAt || a.created_date || 0);
      const dateB = new Date(b.created_on || b.createdAt || b.created_date || 0);
      return dateB - dateA; // Newest first
    });
  };

  const getResourceList = async () => {
    setLoader(true);
    var resourceList = await getData(resourceListURL);
    setLoader(false);

    // Sort the data with newest first
    const sortedResourceList = sortDataByCreatedDate(resourceList);

    setResourceData(sortedResourceList);
    setRowCount(sortedResourceList.length);
    // sendDataToCentralStore(sortedResourceList);
  };

  const searchByRsrcCategory = (event) => {
    var select_id = document.getElementById("resrcCatDropdown");
    let searchString =
      select_id.options[select_id.selectedIndex].text.toLowerCase();
    if (searchString != "all") {
      let rsrcCatArr = [];
      for (let resource in resourceData) {
        let actualString = resourceData[resource].category.toLowerCase();
        if (actualString.indexOf(searchString) > -1) {
          rsrcCatArr.push(resourceData[resource]);
        }
      }
      // Sort filtered data as well
      setResourceSrchdData(sortDataByCreatedDate(rsrcCatArr));
    } else {
      setResourceSrchdData(resourceData);
    }
  };

  const searchRsrcByType = (event) => {
    getRsourceCategoryList(event.target.value);
  };

  const getRsourceCategoryList = async (activity) => {
    var resourceCategoryList = await getData(resourceCatListURL + activity);
    for (let resourceCat in resourceCategoryList) {
      resourceCategoryList[resourceCat]["label"] =
        resourceCategoryList[resourceCat]["category"];
      resourceCategoryList[resourceCat]["value"] =
        resourceCategoryList[resourceCat]["category"];
    }
    setResourceCategoryData(resourceCategoryList);
  };

  const getRsourceTypeList = async () => {
    var resourceActList = await getData(resourceActivityListURL);
    for (let resource in resourceActList) {
      resourceActList[resource]["label"] =
        resourceActList[resource]["activity"];
      resourceActList[resource]["value"] =
        resourceActList[resource]["activity"];
    }
    //resourceActList.unshift({ id: "All", value: "ALL" });
    setResourceTypeData(resourceActList);
    getRsourceCategoryList(resourceActList[0]["activity"]);
  };

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = resourcemgmtcolumnsForExport;

      // Transform the data to include calculated available quantity
      const transformedData = data.map(row => ({
        ...row,
        available_quantity: (() => {
          const totalQuantity = row.total_quantity || 0;
          const damagedQuantity = row.damaged_quantity || 0;
          const deployQuantity = row.deploy_quantity || 0;

          const availableQuantity = totalQuantity - damagedQuantity - deployQuantity;
          return availableQuantity >= 0 ? availableQuantity : 0;
        })()
      }));

      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, transformedData),
        })
      );
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("resourcetableheaders.resourcename"),
        accessor: "resource_name",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            if (props.value.length > 15) {
              descriptionText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
      },
      // {
      //   Header: t("resourcetableheaders.resourceactivity"),
      //   accessor: "rsrc_activity_id",
      //   disableSortBy: true,
      // },
      {
        Header: t("resourcetableheaders.resourcecategory"),
        accessor: "rsrc_cat_id",
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            if (props.value.length > 15) {
              descriptionText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: (
          <div style={{ textAlign: 'center' }}>
            Total Quantity<br />(Incl. OOS/Damaged Quantity)
          </div>
        ),
        accessor: "total_quantity",
        disableSortBy: true,
        Cell: (props) => {
          return (
            <div style={{ textAlign: 'center', fontWeight: "bold" }}>
              {props.value ? props.value : "NA"}
            </div>
          );
        },
      },
      {
        Header: t("resourcetableheaders.damagedquantity"),
        accessor: "damaged_quantity",
        disableSortBy: true,
        Cell: (props) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {props.value !== undefined && props.value !== null ? props.value : "NA"}
            </div>
          );
        },
      },
      {
        Header: t("resourcetableheaders.deployquantity"),
        accessor: "deploy_quantity",
        disableSortBy: true,
        Cell: (props) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {props.value !== undefined && props.value !== null ? props.value : "0"}
            </div>
          );
        },
      },
      {
        Header: t("resourcetableheaders.availablequantity"),
        accessor: "available_quantity",
        disableSortBy: true,
        Cell: (props) => {
          // Calculate available quantity as total - damaged - deployed
          const totalQuantity = props.row.original.total_quantity || 0;
          const damagedQuantity = props.row.original.damaged_quantity || 0;
          const deployQuantity = props.row.original.deploy_quantity || 0;

          const availableQuantity = totalQuantity - damagedQuantity - deployQuantity;

          return (
            <div style={{ textAlign: 'center' }}>
              {availableQuantity >= 0 ? availableQuantity : 0}
            </div>
          );
        },
      },
      {
        Header: t("resourcetableheaders.agencyname"),
        accessor: "agency_name",
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            if (props.value.length > 15) {
              descriptionText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("resourcetableheaders.districtname"),
        accessor: "dist_name",
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            if (props.value.length > 15) {
              descriptionText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("resourcetableheaders.regionname"),
        accessor: "region_name",
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            if (props.value.length > 15) {
              descriptionText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      // Uncomment and modify this column if you want to show the creation date
      {
        Header: t("resourcetableheaders.facility"),
        accessor: "facility",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            if (props.value.length > 15) {
              descriptionText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("resourcetableheaders.action"),
        disableSortBy: true,
        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteResourcebyId, data, {});
            if (res.status == "success") {
              getResourceList();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000, // Close after 2 seconds
            });
            setIsdelete(false);
          };

          return (
            <div className="usertable__actionsicon">

              <span
                className={`resource__table--icons ${props.row.original.is_deployed ? 'disabled-icon' : ''}`}
                onClick={() => {
                  // Only allow navigation if not deployed
                  if (!props.row.original.is_deployed) {
                    navigate("/resource-list/create-resource", {
                      state: {
                        data: props.row.original.id,
                        edit: true
                      },
                    });
                  }
                }}
                style={{
                  cursor: props.row.original.is_deployed ? 'not-allowed' : 'pointer',
                  opacity: props.row.original.is_deployed ? 0.5 : 1
                }}
                title={props.row.original.is_deployed ? "Editing is disabled while the resource is actively deployed. Please release the resource to enable editing" : ""}
              >
                <Editicon
                  className={`${props.row.original.is_deployed ? '' : 'cursor-pointer'} mr-1`}
                  value={props.value}
                />
              </span>

              {roleName === process.env.REACT_APP_SUPER_ADMIN && (
                <span
                  className={`resource__table--icons ${props.row.original.is_deployed ? 'disabled-icon' : ''}`}
                  onClick={() => {
                    // Only allow delete if not deployed
                    if (!props.row.original.is_deployed) {
                      deletePopUp();
                    }
                  }}
                  style={{
                    cursor: props.row.original.is_deployed ? 'not-allowed' : 'pointer',
                    opacity: props.row.original.is_deployed ? 0.5 : 1
                  }}
                  title={props.row.original.is_deployed ? "Deletion is disabled while the resource is actively deployed. Please release the resource to enable deletion" : ""}
                >
                  <Deleteicon
                    value={props.value}
                    className={`${props.row.original.is_deployed ? '' : 'cursor-pointer'} mr-1`}
                  />
                </span>

              )}

              {isdelete && (
                <Confirmpopup
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={""}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    [t, roleName]
  );

  return (
    <div>
      <div className="create-user">
        <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        />
        <div className="datatable__container" style={{ marginTop: "21px" }}>
          <div className="ps-3 w-100 searchRsrcContainer d-flex float-start position-relative">
            {/* District Dropdown */}
            <div className="district-dropdown-fixed" style={{
              position: "absolute",
              top: "-38px",
              right: "288px",
              width: "200px",
              zIndex: 10
            }}>
              <label className="mb-2">{t("floodreport.district")}</label>
              <div>
                <SelectComponent
                  id="districtDropdown"
                  classList={"me-2"}
                  onChange={filterByDistrict}
                  options={districtData}
                  value={districtData.find(d => d.id === selectedDistrict)}
                  isLoading={districtsLoading}
                  placeholder={districtsLoading ? "Loading districts..." : "Select district"}
                />
              </div>
            </div>

            {/* <SelectComponent
              id="resrcTypeDropdown"
              classList={"me-2"}
              onChange={searchRsrcByType}
              options={resourceTypeData}
            />
 
            <SelectComponent
              onChange={searchByRsrcCategory}
              id="resrcCatDropdown"
              options={resourceCategoryData}
            /> */}
          </div>

          {resourceData && (
            <Table
              data={
                resourceSrchdData != null ? resourceSrchdData : resourceData
              }
              addButtonLabel={t("resourceaddButtonLabel")}
              addNewHandler={addNewHandler}
              columns={columns}
              numberOfRows={10}
              showExport={false}
              setSearchData={setSearchData}
              showFilter={false}
              showReset={false}
              onExpand={false}
              enableColumnFilters={true}
              resourceTable={true}
              rowCount={rowCount} // Pass rowCount to the Table component
              headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF", verticalAlign: "top" }}
              tableStyle={{
                border: "1px solid  #f0f0f0",
                borderRadius: "12px",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
});

export default ResourceTable;